import '@angular/compiler';
import { LayoutMainComponent } from './layout.main/layout.main.component';
import { PageMainComponent } from './page.main/page.main.component';

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { URLPattern } from 'urlpattern-polyfill';

const appRoutes: Routes = [
    {
        component: LayoutMainComponent,
        "children": [
            {
                "path": "",
                component: PageMainComponent,
                "app_id": "page.main"
            }
        ]
    }
];

export class RouteInfo {
    public path: string = '';
    public segment: Record<string, string> = {};
}

window.WizRoute = new RouteInfo();

const patternMatcher = (routePattern: string, url: any[]) => {
    const pathname = `/${String(routePattern || '').replace(/^\/+/, '')}`;
    const urlPath = `http://localhost/${url.map((segment: any) => segment.path).join('/')}`;
    const match = new URLPattern({ pathname }).exec(urlPath);

    if (!match?.pathname) return null;

    const posParams: Record<string, string> = {};
    for (const key in match.pathname.groups) {
        const value = match.pathname.groups[key];
        if (value) posParams[key] = value;
    }

    window.WizRoute.path = url.map((segment: any) => segment.path).join('/');
    window.WizRoute.segment = posParams;

    return { consumed: url, posParams };
};

const routes: Routes = appRoutes.map((layout: any) => ({
    path: '',
    component: layout.component,
    children: layout.children.map((child: any) => ({
        matcher: (url: any[]) => patternMatcher(child.path, url),
        component: child.component
    }))
}));

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
